import axios from 'neo-axios';
import rawAxios from 'axios';
import { getHeader } from 'neo-axios';
import utils from '@/utils/utils';
import { options } from 'less';

/**
 * api
 */
const userId = utils.getUserInfo('id');
const userName = utils.getUserInfo('name');
const pageSize = process.env.VUE_APP_page_size * 1;

const CIMS_API = `${config.api.cims}/api`;

const API = {
  system: {
    //退出系统
    logout: () => axios.$post(`${config.api.uc}/api/account/logout`),
  },
  uc: {
    authenticatedAccount: (accountId, password) =>
      axios.$post(`${config.api.uc}/api/account/authenticatedAccount`, {
        accountId,
        password: utils.md5(password),
      }),
  },
  mol: {
    search: options => axios.$post(`${config.api.mol}/api/mol/search`, options),
  },
  cims: {
    //
    getSupplierList: supplier => axios.$get(`${CIMS_API}/purchases/supplierList/${supplier}`),
    //获取物料模板详情
    getMaterielTpl: id => axios.$get(`${CIMS_API}/materiel/${id}`),
    // 我的领用
    fetchRequestData: requestType =>
      axios.$post(`${CIMS_API}/requests/requestsInfo`, {
        requesterId: userId,
        requestsInfoType: requestType,
        count: 6,
        requestType: 'chemicalReagents',
      }),
    //领用统计
    fetchRequestStatisticData: () =>
      axios.$post(`${CIMS_API}/report/custom/requests`, {
        startDate: utils.getPrevWeek(),
        endDate: utils.getcurDate(),
        createUserId: userId,
      }),
    //领用统计
    fetchRequestStatisticData1: options =>
      axios.$post(
        `${CIMS_API}/report/custom/requests`,
        Object.assign(
          {
            pageIndex: 1,
            pageSize: pageSize,
            createUserId: userId,
          },
          options
        )
      ),
    //领用审批
    fetchRequestApproveData: () =>
      axios.$post(`${CIMS_API}/requests/requestsApprovalInfo`, {
        approverId: userId,
        count: 6,
        requestType: 'chemicalReagents',
      }),
    //申购审批
    fetchApplicantApproveData: () =>
      axios.$post(`${CIMS_API}/purchases/approvingHistory`, {
        pageIndex: 1,
        pageSize: 6,
        purchaseType: `chemicalReagents`,
      }),
    //获取申购单详情
    getApplicant: id => axios.$get(`${CIMS_API}/purchases/${id}`),
    //修改申购单
    editApplicant: (id, options) => axios.$put(`${CIMS_API}/purchases/${id}`, options),
    //获取领用单详情
    getRequestApproveDetail: id => axios.$get(`${CIMS_API}/requests/approvalDetails/${id}`),
    //获取审批流程
    getFlows: id => axios.$get(`${CIMS_API}/orderFlow/flowNode/${id}`),
    //我的申购
    fetchApplicantData: () =>
      axios.$post(`${CIMS_API}/purchases/page`, {
        pageIndex: 1,
        pageSize: 6,
        purchasesState: `processed`,
        purchaseType: 'chemicalReagents',
      }),
    //审批统计
    fetchApproveStatisticData: () =>
      axios.$post(`${CIMS_API}/report/custom/approve`, {
        startDate: utils.getPrevWeek(),
        endDate: utils.getcurDate(),
        createUserId: userId,
      }),
    //审批统计
    fetchApproveStatisticData1: options =>
      axios.$post(
        `${CIMS_API}/report/custom/approve`,
        Object.assign(
          {
            pageIndex: 1,
            pageSize: pageSize,
            createUserId: userId,
          },
          options
        )
      ),
    //通知公告
    fetchNoticeData: () =>
      axios.$get(`${CIMS_API}/notices/noticesInfo`, {
        count: 8,
      }),
    //通知公告分页
    fetchNoticePageData: options =>
      axios.$post(`${CIMS_API}/notices/Page`, {
        pageSize: pageSize,
        ...options,
      }),
    //通知公告详情
    fetchNoticeDetailData: id => axios.$get(`${CIMS_API}/notices/${id}`),
    //我借用的
    fetchBorrowedData: () =>
      axios.$post(`${CIMS_API}/bottleBorrow/myBorrow`, {
        count: 6,
        createUserId: userId,
      }),
    //我借出的
    fetchLendData: options =>
      axios.$post(`${CIMS_API}/bottleBorrow/bottleLend/myLend`, {
        count: 6,
        lenderId: userId,
      }),
    //试剂借出
    LendTA: options =>
      axios.$post(`${CIMS_API}/bottleBorrow/bottleLend`, {
        lender: userName,
        lenderId: userId,
        ...options,
      }),
    //TA的借用
    fetchPostLendData: () =>
      axios.$post(`${CIMS_API}/bottleBorrow/ranking`, {
        count: 6,
        requesterId: userId,
      }),
    //TA的借用分页
    fetchLendPageData: options =>
      axios.$post(`${CIMS_API}/bottleBorrow/rankingPage`, {
        requesterId: userId,
        ...options,
      }),
    fetchBottleBorrowData: id => axios.$get(`${CIMS_API}/bottleBorrow/${id}`),
    fetchBottleBorroRequestsData: options =>
      axios.$post(`${CIMS_API}/bottleBorrow/requests`, {
        pageSize: pageSize,
        requesterId: userId,
        ...options,
      }),
    fetchMyBorrowData: options =>
      axios.$post(`${CIMS_API}/bottleBorrow/myBorrowPage`, {
        pageSize: pageSize,
        createUserId: userId,
        ...options,
      }),
    fetchMyLendData: options =>
      axios.$post(`${CIMS_API}/bottleBorrow/bottleLend/myLendPage`, {
        pageSize: pageSize,
        lenderId: userId,
        ...options,
      }),
    confirmBottleReceive: id => axios.$put(`${CIMS_API}/bottleBorrow/receive/${id}`),
    //未读消息
    fetchUnreadMessageData: () =>
      axios.$get(`${CIMS_API}/messages/unreadCount`, {
        receiverId: userId,
        messageType: '',
      }),
    //领用车信息
    fetchShoppingCartData: () => axios.$get(`${CIMS_API}/requests/cartCount?timeStamp=${utils.getTimeStamp()}`),
    //molFile加载试剂
    fetchMolFileSearchData: (molecule, pageIndex = 1) =>
      axios.$post(`${CIMS_API}/mol/search`, {
        molecule,
        pageIndex,
      }),
    //molFile加载试剂
    fetchSOIdsSearchData: sourceOrganIds =>
      axios.$post(`${CIMS_API}/compounds/mol/search`, {
        sourceOrganIds,
      }),
    //可用瓶数
    fetchBottleInventoryData: compoundIds =>
      axios.$post(`${CIMS_API}/compounds/manyBottleInventoryQuantity`, {
        compoundIds,
      }),
    //是否收藏
    fetchIsFavoriteData: compoundIds =>
      axios.$post(`${CIMS_API}/favorites/hasFavorite`, {
        compoundIds,
        userId,
      }),

    //可以领用的试剂
    fetchAvailableBottleData: options =>
      axios.$post(`${CIMS_API}/bottles/availableBottles`, {
        userId: userId,
        pageSize,
        ...options,
      }),
    //理论可以领用的试剂
    fetchTheoryBottleData: (compoundId, purity, bottleType, supplier, origin) =>
      axios.$post(`${CIMS_API}/bottles/theoryBottles`, {
        userId: userId,
        compoundId,
        purity,
        bottleType,
        supplier,
        origin,
      }),
    //添加到领用车
    addToCart: (item, fileType) =>
      axios.$post(`${CIMS_API}/requests/join`, {
        userId: userId,
        fkID: item.ID,
        amount: 300,
        foreignKeyId: item.WarehouseId,
        chinName: item.ChinName,
        compoundId: item.CompoundId,
        requestType: fileType * 1,
        requesterId: userId,
        requester: userName,
        requestUnit: item.Unit,
        requestQuantity: item.CurrentQuantity,
        barcode: item.Barcode,
        lab: utils.getCimsInfo().UserInfo.LabName,
        phone: utils.getUserInfo(`all`).MobilePhone,
        warehouseId: item.WarehouseId,
      }),
    //化合物详情
    getCompound: materielId =>
      axios.$post(`${CIMS_API}/compounds/detail`, {
        userId,
        materielId,
      }),
    //试剂详情
    getReagent: options => axios.$post(`${CIMS_API}/bottles/detail`, options),
    //物料详情
    getMateriel: MaterielNumber => axios.$get(`${CIMS_API}/materiel/detail/${MaterielNumber}`),
    //物料详情
    getMaterielById: id => axios.$get(`${CIMS_API}/materiel/${id}`),
    //试剂领用-全部
    getRequestTable1: options => axios.$post(`${CIMS_API}/requests/history`, Object.assign(options, { requesterId: userId })),
    //试剂领用-待审批
    getRequestTable2: options => axios.$post(`${CIMS_API}/requests/approvingHistory`, Object.assign(options, { requesterId: userId })),
    //试剂领用-已拒绝
    getRequestTable3: options => axios.$post(`${CIMS_API}/requests/refusedHistory`, Object.assign(options, { requesterId: userId })),
    //试剂领用-待签收
    getRequestTable4: options => axios.$post(`${CIMS_API}/requests/receivingHistory`, Object.assign(options, { requesterId: userId })),
    //试剂领用-已签收(有人值守)
    getRequestTable5: options => axios.$post(`${CIMS_API}/requests/receiveHistory`, Object.assign(options, { requesterId: userId })),
    //试剂领用-已签收（无人值守）
    getRequestTable6: options => axios.$post(`${CIMS_API}/requests/receiveHistoryNoOpera`, Object.assign(options, { requesterId: userId })),
    //试剂领用-已退库
    getRequestTable7: options => axios.$post(`${CIMS_API}/requests/returnStockHistory`, Object.assign(options, { requesterId: userId })),
    //试剂领用-已报废
    getRequestTable8: options => axios.$post(`${CIMS_API}/requests/scrapHistory`, Object.assign(options, { requesterId: userId })),
    //试剂领用-已分装
    getRequestTable9: options => axios.$post(`${CIMS_API}/requests/subPackageHistory `, Object.assign(options, { requesterId: userId, isSub: true })),
    //试剂领用-指派记录
    getRequestTable10: options => axios.$post(`${CIMS_API}/requests/my/assignRecord/pages`, options),
    //试剂领用-分瓶预定记录
    getRequestTable11: options => axios.$post(`${CIMS_API}/BottleSplit/Order/Pages`, options),
    //领用审批
    fetchRequestApproveTab1: options => axios.$post(`${CIMS_API}/requests/approval`, Object.assign({ pageSize, approverId: userId }, options)),
    //领用审批
    fetchRequestApproveTab2: options => axios.$post(`${CIMS_API}/requests/approvalHistory`, Object.assign({ pageSize, approverId: userId }, options)),
    //领用审批
    fetchRequestApproveTab3: options =>
      axios.$post(`${CIMS_API}/requests/approvalRefusedHistory`, Object.assign({ pageSize, approverId: userId }, options)),
    //领用审批-批量同意
    requestApproveYes: approveList => axios.$post(`${CIMS_API}/requests/approve`, { approveList }),
    //领用审批-批量拒绝
    requestApproveNo: approveList => axios.$post(`${CIMS_API}/requests/refuse`, { approveList }),
    //我的申购
    fetchMyApplicantData: options => axios.$post(`${CIMS_API}/purchases/page`, Object.assign({ pageSize }, options)),
    //我的申购-已拒绝
    fetchMyApplicantRefuseData: options => axios.$post(`${CIMS_API}/purchases/refused/page`, Object.assign({ pageSize }, options)),
    //我的申购审批-待审批
    fetchMyApplicantApproveDataTab1: options => axios.$post(`${CIMS_API}/purchases/approvingHistory`, Object.assign({ pageSize }, options)),
    //我的申购审批-已审批
    fetchMyApplicantApproveDataTab2: options => axios.$post(`${CIMS_API}/purchases/approvedHistory`, Object.assign({ pageSize }, options)),
    //我的申购审批-已拒绝
    fetchMyApplicantApproveDataTab3: options => axios.$post(`${CIMS_API}/purchases/refusedHistory`, Object.assign({ pageSize }, options)),
    //申购审批-批量同意
    applicantApproveYes: options =>
      axios.$post(`${CIMS_API}/purchases/approve`, {
        approveList: options.map(item => {
          item.approveUser = userId;
          return item;
        }),
      }),
    //申购审批-批量拒绝
    applicantApproveNo: options =>
      axios.$post(`${CIMS_API}/purchases/refuse`, {
        approveList: options.map(item => {
          item.approveUser = userId;
          return item;
        }),
      }),
    //我的申购-批量提交
    batchSubmitApplicant: purchasesCommitList =>
      axios.$post(`${CIMS_API}/purchases/commit`, {
        purchasesCommitList,
      }),
    //我的申购-待提交-批量删除
    batchDeleteApplicant: ids => axios.$delete(`${CIMS_API}/purchases`, ids),
    //我的申购-批量撤回
    batchRecallApplicant: options => axios.$post(`${CIMS_API}/purchases/revoke`, options),
    //申购单审批详情
    getPurchase: id => axios.$get(`${CIMS_API}/purchases/approveDetail/${id}`),
    //申购单详情
    getBttlesInventory: options => axios.$post(`${CIMS_API}/bottles/inventory`, options),
    //根据化合物，获取已经审批通过并且是未到货状态的采购信息
    fetchPurchasesCompoundArriveData: options => axios.$post(`${CIMS_API}/purchases/compound/arrive`, options),
    //无人值守领用单
    getNoOperaRequisitionList: () => axios.$get(`${CIMS_API}/requests/cartNoOpera`),
    //有人值守领用单
    getRequisitionList: () => axios.$get(`${CIMS_API}/requests/cart`),
    //cims配置信息
    getOrganizationConfig: code => axios.$get(`${CIMS_API}/organizationConfig/${code}`),
    //cims组织配置信息
    getSystemConfig: code => axios.$get(`${CIMS_API}/organizationConfig/configValue/${code}`),
    //删除领用车
    deleteShoppingCart: ids => axios.$delete(`${CIMS_API}/requests`, ids),
    //提交领用车
    submitShoppingCart: requestsCommitList => axios.$post(`${CIMS_API}/requests/commit`, { requestsCommitList, userId, userName }),
    //分装退库
    submitSplitStock: requestsCommitList => axios.$post(`${CIMS_API}/requests/unattendedOperation/subpackage`, { requestsCommitList, userName }),
    //领用详情
    fetchRequestDetail: id => axios.$get(`${CIMS_API}/requests/requestsDetails/${id}`),
    //领用详情
    fetchRequestDocDetail: (id, requestType) =>
      axios.$post(`${CIMS_API}/docFiles/requestsDetails`, {
        requestCode: id,
        requestType: requestType,
      }),
    //加载字典
    fetchDicItem: dic => axios.$get(`${CIMS_API}/dictionary/dicItem/${dic}`),
    //加载项目
    fetchProjects: () => axios.$get(`${CIMS_API}/projects/my`),
    //加载项目
    fetchMyProjects: () => axios.$get(`${CIMS_API}/projects/my`),
    //提交领用单
    submitApplicant: options => axios.$post(`${CIMS_API}/purchases/join`, options),
    //提交领用单
    submitDocFiles: options => axios.$post(`${CIMS_API}/requests/docFilesCommit`, options),
    //提交spz
    submitSpzFiles: options => axios.$post(`${CIMS_API}/requests/ColumnsCommit`, options),
    //玻璃耗材-报废申请
    submitConsumablesScraps: options =>
      axios.$post(
        `${CIMS_API}/consumablesScraps`,
        Object.assign(options, {
          wastager: userName,
          applicant: userName,
          applicantId: userId,
          scrapType: 1,
        })
      ),
    //我的收藏
    fetchFavoriteData: options =>
      axios.$post(`${CIMS_API}/favorites/page`, {
        pageSize,
        createUserId: userId,
        ...options,
      }),
    //我的收藏
    getFavoriteCount: () => axios.$get(`${CIMS_API}/favorites/count?timeStamp=${utils.getTimeStamp()}`),
    //我的消息
    fetchMessageData: options =>
      axios.$post(
        `${CIMS_API}/messages/page`,
        Object.assign(options, {
          pageSize: pageSize,
          receiverId: userId,
        })
      ),
    //设为已读
    batchReadMessage: options => axios.$put(`${CIMS_API}/messages/setAsRead`, options),
    //批量删除
    batchDeleteMessage: ids => axios.$delete(`${CIMS_API}/messages`, ids),
    //我的申购 - 其他tab
    fetchPurchaseTab2: options => axios.$post(`${CIMS_API}/purchases/processedPage`, options),
    // 我的申购-待接收
    fetchPurchaseTab1: options => axios.$post(`${CIMS_API}/purchases/pendingPage`, options),
    //cas校验
    isCasExist: casNumber => axios.$get(`${CIMS_API}/compounds/isExists/${casNumber}`),
    //根据cas号获取单个化合物资源对象
    findCompoundSourceByCas: casNumber => axios.$get(`${CIMS_API}/compoundSource/findCompoundSource/${casNumber}`),
    //我的申购-选择物料
    fetchMaterielsPageData: options =>
      axios.$post(`${CIMS_API}/materiel/page`, {
        pageSize,
        ...options,
      }),
    purchasesHandle: options =>
      axios.$post(
        `${CIMS_API}/purchases/handle`,
        Object.assign(options, {
          purchaser: userName,
        })
      ),
    //采购单--批量接收
    purchasesUpdateHandle: options => axios.$post(`${CIMS_API}/purchases/purchasesUpdate`, options),
    //采购单--批量修改采购单
    batchModifyPurchases: options => axios.$post(`${CIMS_API}/purchases/changePurchaseInfo`, options),
    //采购单--批量收货
    purchasesReceivedHandle: options =>
      axios.$post(`${CIMS_API}/purchases/arrive`, {
        userName,
        ...options,
      }),
    //采购单--结算
    settleAccountsHandle: options => axios.$post(`${CIMS_API}/purchases/settleAccounts`, options),
    //采购单-批量导出
    batchExportPurchase: options => axios.$post(`${CIMS_API}/purchases/export`, options),

    tkOperation: options =>
      axios.$post(`${CIMS_API}/returnStockApplication/batchReturnStock`, {
        applicant: userName,
        applicantId: userId,
        ...options,
      }),
    bfOperation: options =>
      axios.$post(`${CIMS_API}/scrapApplication/batchScrap`, {
        applicant: userName,
        ...options,
      }),
    cfOperation: options => axios.$post(`${CIMS_API}/requests/batchStore`, options),
    //发布借用-搜索化合物
    fetchBorrowCanViewRequestHistoryData: options =>
      axios.$post(`${CIMS_API}/compounds/page`, {
        pageSize: pageSize,
        ...options,
      }),
    //发布借用-化合物领用记录
    fetchDeliveredRequestsData: options => axios.$post(`${CIMS_API}/requests/deliveredRequests/`, options),
    //
    postBorrowInfo: options =>
      axios.$post(`${CIMS_API}/bottleBorrow/`, {
        createUser: userName,
        createUserId: userId,
        ...options,
      }),
    //加载物料类型
    fetchMaterielTypesData: () => axios.$post(`${CIMS_API}/materielCustomTemplate/templates`),
    //加载仓库
    fetchWarehousesData: (storageType = '') => axios.$get(`${CIMS_API}/warehouses/my/${storageType}`),
    // 根据物料编号集合获取可存放仓库集合
    getWarehouses: options => axios.$post(`${CIMS_API}/warehouses/getWarehousesForMateriels`, options),
    // 根据物料编号集合获取有权限的可存放仓库集合
    getAuthWarehouses: options => axios.$post(`${CIMS_API}/warehouses/getAuthWarehousesForMateriels`, options),
    //加载库位
    getShelves: (warehouseId, code) => axios.$get(`${CIMS_API}/warehouses/shelves/${warehouseId}/${code}`),
    //关键字搜索物料
    fetchMaterielsData: options => axios.$post(`${CIMS_API}/materiel/search`, { pageSize: 30, ...options }),
    //是否收藏检验
    isFavoritCheck: materielIds => axios.$post(`${CIMS_API}/favorites/hasFavorite`, { userId, materielIds }),
    //添加到收藏
    addToFavorite: options => axios.$post(`${CIMS_API}/favorites`, { createUserId: userId, ...options }),
    //取消收藏
    cancelFavorite: id => axios.$delete(`${CIMS_API}/Favorites/${id}`),
    //提交领用车
    submitRequest: options =>
      axios.$post(`${CIMS_API}/requests/join`, {
        requester: userName,
        requesterId: userId,
        userId,
        ...options,
      }),
    //提交领用车
    fetchRequestHistory: options =>
      axios.$post(`${CIMS_API}/requests/latest`, {
        pageSize,
        ...options,
      }),
    // 根据barCode获取领用历史
    fetchRequestHistoryByCode: options =>
      axios.$post(`${CIMS_API}/requests/BottleLatest`, {
        pageSize,
        ...options,
      }),
    //加载物料类型
    fetchMaterielType: () => axios.$post(`${CIMS_API}/materielCustomTemplate/templates`),
    //我的项目-管理员
    fetchProjectManagerData: options =>
      axios.$post(`${CIMS_API}/projects/manage/page`, {
        pageIndex: 1,
        sortFiled: 'CreateTime',
        sort: 'DESC',
        pageSize,
        ...options,
      }),
    //我的项目-普通成员
    fetchProjectData: options =>
      axios.$post(`${CIMS_API}/projects/page`, {
        pageIndex: 1,
        pageSize,
        sortFiled: 'CreateTime',
        sort: 'DESC',
        ...options,
      }),
    //我的项目-获取当前组织下的用户列表
    fetchProjectMemberData: options => axios.$get(`${CIMS_API}/users`),
    //我的项目-新建项目
    newProject: options =>
      axios.$post(`${CIMS_API}/projects`, {
        createUserId: userId,
        createUser: userName,
        ...options,
      }),
    //我的项目-删除项目
    deleteProject: id => axios.$delete(`${CIMS_API}/projects`, [id]),
    //我的项目-编辑项目
    editProject: (id, options) => axios.$put(`${CIMS_API}/projects/${id}`, options),
    //我的项目-项目详情
    fetchProject: id => axios.$get(`${CIMS_API}/projects/${id}`),
    //我的项目-启用禁用项目
    toggleProjectState: options => axios.$post(`${CIMS_API}/projects/enable`, options),
    //废弃收集-配置项
    fetchChemicalConfigData: () => axios.$get(`${CIMS_API}/chemicalWasteType/findAllType`),
    //废弃收集-新增
    addChemicalData: options =>
      axios.$post(`${CIMS_API}/chemicalWaste`, {
        createUserId: userId,
        createUser: userName,
        ...options,
      }),
    //废弃收集-编辑
    editChemicalData: (id, options) =>
      axios.$put(`${CIMS_API}/chemicalWaste/${id}`, {
        createUserId: userId,
        createUser: userName,
        ...options,
      }),
    //废弃分页
    fetchWasteData: options => axios.$post(`${CIMS_API}/chemicalWaste/page`, { pageSize, ...options }),
    //废弃分页-删除
    deleteWaste: id => axios.$delete(`${CIMS_API}/chemicalWaste`, [id]),
    //废弃分页-获取详情
    getWaste: id => axios.$get(`${CIMS_API}/chemicalWaste/${id}`),
    //领用单-无人值守-退库
    noOperationReturnStock: options => axios.$post(`${CIMS_API}/requests/unattendedOperation/returnStock`, [{ ...options, userId, userName }]),
    //领用单-无人值守-报废-上传附件
    UploadFileOrgan: `${CIMS_API}/upload/uploadFileOrgan/scrap`,
    //领用单-无人值守-报废
    noOperationScrap: options => axios.$post(`${CIMS_API}/requests/unattendedOperation/scrap`, [{ ...options, userId, userName }]),
    getIminentExpirationMsg: id => axios.$get(`${CIMS_API}/OrganizationConfig/GetIminentExpirationMsg?deptId=${id}`),
    loadDepartmentList: () => axios.$get(`${CIMS_API}/loadDepartmentList`),
    //获取当前登录用户管理的无人值守的仓库
    getUnattendedWarehouseList: () => axios.$get(`${CIMS_API}/warehouses/getUserKeeperWarehouses?isUnattended=true`),
    // 采购单-待接收批量退回
    batchReturnReceivingPurchases: options => axios.$post(`${CIMS_API}/purchases/purchasesRefused`, { ...options, operator: userName }),
    // 采购单-待接收采购结束
    batchEndReceivingPurchases: options => axios.$post(`${CIMS_API}/purchases/purchasesEnd`, { ...options, operator: userName }),
    // 获取组织下所有项目
    getAllProjectList: () => axios.$get(`${CIMS_API}/projects/getProjects`),
    // 是否授权cims
    isAuthorizedCims: () => axios.$post(`${CIMS_API}/users/isAuthorizeLogin`, { platform: 'cims' }),
    // 根据cas号获取物料列表
    getMaterielList: options =>
      axios.$post(
        `${CIMS_API}/compounds/isExistsCompounds/${options.casNumber}`,
        Object.assign(
          {
            pageIndex: 1,
            pageSize: pageSize,
          },
          options
        )
      ),
    // 全部领用搜索出的试剂
    batchJoin: options => axios.$post(`${CIMS_API}/requests/batchJoin`, options),
    // 添加领用单的使用记录
    addUsageHistory: options => axios.$post(`${CIMS_API}/Bottles/AddStockUsageRecord`, options),
    // 编辑领用单的使用记录
    editUsageHistory: options => axios.$post(`${CIMS_API}/Bottles/ModifyStockUsageRecord`, options),
    // 获取领用单的使用记录
    getUsageHistoryList: requestId => axios.$get(`${CIMS_API}/Bottles/QueryRecordByRequestId/${requestId}`),
    // 删除使用记录
    deleteUsageHistory: id => axios.$get(`${CIMS_API}/Bottles/DeleteStockUsageRecord/${id}`),
    // 获取使用记录修改日志列表
    getUsageHistoryLogList: requestId => axios.$get(`${CIMS_API}/Bottles/QueryStockUsageOperationByRequestId/${requestId}`),
    // 自取签收领用单
    selfTakeReceive: options => axios.$post(`${CIMS_API}/Deliveries/CompleteSelfDeliver`, options),
    // 电子签名批量校验（双人双锁）
    esignVerifyBatch: options => axios.$post(`${CIMS_API}/Users/Esign/Verify/Batch`, options),
    // 获取仓库库管员（双人双锁共同操作人候选）
    getWarehouseKeepers: warehouseId => axios.$get(`${CIMS_API}/Warehouses/Keepers/${warehouseId}`),
    // 扫码加入领用单
    scanJoin: options => axios.$get(`${CIMS_API}/requests/appScanJoin/${options.barcode}`, options),
    // 重新提交分瓶领用
    resubmitSplitInfo: options => axios.$post(`${CIMS_API}/BottleSplit/Order/ReCommit`, options),
    //分瓶领用审批
    fetchSplitRequestApproveTab1: options => axios.$post(`${CIMS_API}/BottleSplit/Order/Approving/Pages`, Object.assign({ pageSize }, options)),
    //分瓶领用审批
    fetchSplitRequestApproveTab2: options => axios.$post(`${CIMS_API}/BottleSplit/Order/Approved/Pages`, Object.assign({ pageSize }, options)),
    //分瓶领用审批
    fetchSplitRequestApproveTab3: options => axios.$post(`${CIMS_API}/BottleSplit/Order/Rejected/Pages`, Object.assign({ pageSize }, options)),
    // 提交分瓶领用表单
    submitSplitRequest: options => axios.$post(`${CIMS_API}/BottleSplit/Order/Commit`, options),
    // 获取分瓶信息分页
    fetchSplitRequestInfoTable: options =>
      axios.$post(`${CIMS_API}/BottleSplit/Order/Parent/Booked/Pages?NeedOrders=1`, Object.assign({ pageSize }, options)),
    // 分瓶领用审批
    splitRequestApprove: options => axios.$post(`${CIMS_API}/BottleSplit/Order/Approve`, options),
    // 撤回分瓶领用
    recallSplitRequest: options => axios.$post(`${CIMS_API}/BottleSplit/Order/Cancel`, options),
    // 获取分瓶领用的审批详情
    getSplitRequestApproveDetail: orderNumber => axios.$get(`${CIMS_API}/BottleSplit/Order/Approval/Detail/${orderNumber}`),
    // 根据仓库ID集合获取审批流程
    getFlowsByWarehouseIds: warehouseIds => axios.$post(`${CIMS_API}/Flow/Links/Request`, warehouseIds),
    // 根据仓库ID集合获取审批流程
    getFlowsByAmounts: amounts => axios.$post(`${CIMS_API}/Flow/Links/Purchase`, amounts),
    // 批量导入申购单
    batchImportApplicant: options => axios.$post(`${CIMS_API}/Purchases/BatchImport`, options),
    // 下载批量导入申购单模板（返回完整响应以读取 content-disposition）
    downloadBatchImportApplicantTemplate: () =>
      rawAxios.get(`${CIMS_API}/Purchases/template/export`, {
        responseType: 'blob',
        headers: getHeader(),
      }),
  },
};

export default API;
